import apiClient from '../network/apiClient'
// import ShowNotifications from '../utils/notification'
// import axios from 'axios';
class dashboardApi {

  async getLatestCustomer(input) {

    try {
      const response = await apiClient.get(`/dashboard/recent-customer`)

      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      // ShowNotifications.showAxiosErrorAlert(error)
      return {
        response: null,
        status: false
      }
    }
  }

  async getTopSelling(input, currency) {
    console.log(input, "iii");

    try {
      const response = await apiClient.get(`/dashboard/top-selling-product`, { params: { dateFilter: input, currency } })

      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      // ShowNotifications.showAxiosErrorAlert(error)
      return {
        response: null,
        status: false
      }
    }
  }

  async getOverAllSales(currency) {
    try {
      const response = await apiClient.get('/dashboard/sales-overview', { params: { currency } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching overall sales:', error);
      throw error;
    }
  }

  async getOverview(input, currency) {
    try {
      const response = await apiClient.get('/dashboard/by-month', { params: { filterType: input, currency } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching overview:', error);
      throw error;
    }
  }

  async getInvoice(currency) {
    try {
      const response = await apiClient.get('/dashboard/invoices', { params: { currency } });
      if (response.status == 200 || response.status == 201) {
        return {
          response: response.data,
          status: true
        }
      } else {
        //ShowNotifications.showAlertNotification('Some thing went wrong', true)
        return {
          status: false
        }
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  }

}

const DashboardApi = new dashboardApi()
export default DashboardApi
